export default __webpack_public_path__ + "static/tag-dont-3-dark-a31324015252f3f4a718f00678fc5c6506a64bfcef11e17e8c615434c78354db.png";